<template>
  <nav v-if="pagination['paginator']['hasPages']">
    <ul class="pagination">
      <!-- Previous Page Link -->
      <li
        v-if="pagination['paginator']['onFirstPage']"
        class="page-item disabled"
        aria-disabled="true"
        :aria-label="pagination['langPrevious']"
      >
        <span class="page-link" aria-hidden="true">&lsaquo;</span>
      </li>
      <li v-else class="page-item">
        <a
          class="page-link"
          :href="pagination['paginator']['previousPageUrl']"
          rel="prev"
          :aria-label="pagination['langPrevious']"
          >&lsaquo;</a
        >
      </li>

      <!-- Pagination Elements -->
      <li
        v-for="(element, index) in flattenElement"
        :key="index"
        class="page-item"
        :class="{
          disabled: !element.url,
          active: isCurrentPage(element),
        }"
        :aria-current="
          element.page === pagination['paginator']['currentPage']
            ? 'page'
            : null
        "
        :aria-disabled="!element.url"
      >
        <component
          :is="isCurrentPage(element) ? 'span' : 'a'"
          class="page-link"
          :href="isCurrentPage(element) ? '' : element.url"
          >{{ element.page }}</component
        >
      </li>

      <!-- Next Page Link -->
      <li v-if="pagination['paginator']['hasMorePages']" class="page-item">
        <a
          class="page-link"
          :href="pagination['paginator']['nextPageUrl']"
          rel="next"
          :aria-label="pagination['langNext']"
          >&rsaquo;</a
        >
      </li>
      <li
        v-else
        class="page-item disabled"
        aria-disabled="true"
        :aria-label="pagination['langNext']"
      >
        <span class="page-link" aria-hidden="true">&rsaquo;</span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    flattenElement() {
      let flattenElement = [];
      Object.keys(this.pagination["elements"]).forEach((index) => {
        const elements = this.pagination["elements"][index];

        if (this.elementIsString(elements)) {
          flattenElement = [...flattenElement, { url: "", page: elements }];
        } else {
          Object.keys(elements).forEach((i) => {
            flattenElement = [...flattenElement, { url: elements[i], page: i }];
          });
        }
      });
      return flattenElement;
    },
  },
  methods: {
    isCurrentPage(element) {
      return element.page == this.pagination["paginator"]["currentPage"];
    },
    elementIsString(elements) {
      return typeof elements === "string";
    },
  },
};
</script>
